import {Button} from '@material-ui/core';
import {observer} from 'mobx-react-lite';
import React, {FC, useCallback, useEffect, useState} from 'react';
import {Link, useHistory} from 'react-router-dom';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CreateIcon from '@material-ui/icons/Create';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import AddToQueueIcon from '@material-ui/icons/AddToQueue';
import {useCommonStyles} from '../../../core/styles';

import {useStore} from '../../../core/store';
import {DialogService} from '../../../core/dialog-service';
import {GameModel} from '../../../core/interfaces';
import {MessageService} from '../../../core/message-service';
import classNames from 'classnames'

export interface GamesListProps {
    onCreateNewGame?: () => void
};

enum pages {
    PAGE_STATE_1,
    PAGE_STATE_2
}

export const GamesChoose2: FC<GamesListProps> = observer((props) => {
    const store = useStore();
    const classes = useCommonStyles();
    const history = useHistory();
    const [page, setPage] = useState(pages.PAGE_STATE_1)
    const [data, setData] = useState({
        firstImage: {
            image: null,
            color: ''
        },
        secondImage: {
            image: null,
            color: ''
        },
        selectedImage: null
    });
    const [images, setImages] = useState([
        {path: "/assets/images/Жираф.png",  id: 1},
        {path: "/assets/images/Заяц.png",  id: 2},
        {path: "/assets/images/Лев.png",  id: 3},
        {path: "/assets/images/Олень.png",  id: 4},
        {path: "/assets/images/Свинка.png",  id: 5}
    ]);
    const colors = ["#ffeb3b", "#4caf50", "#e91e63", "#2196f3", "#fb8c00"]
    const [audio, setAudio] = useState(new Audio('/assets/example.mp3'));

    useEffect(() => {
        document.addEventListener('keydown', keydownListener);
        return () => {
            document.removeEventListener('keydown', keydownListener);
        }
    }, [page, audio])


    function keydownListener (e) {
        if (page === pages.PAGE_STATE_2 && !data.selectedImage) {
            if (e.keyCode == 32 || e.keyCode==13) {
                e.preventDefault()
                const field = e.keyCode == 32 ? 'firstImage' : 'secondImage'
                const audioFile = e.keyCode == 32 ? 'new-audio-1.mp3' : 'new-audio-2.mp3'
                startMusic(data[field].image, audioFile)
                console.log(data[field])
            }
        }
        if (e.keyCode==27) {
            e.preventDefault()
            if (data.selectedImage) {
                resetGame()
            }
        }
    }
    function selectImage (field, image) {
        const copyData = data
        copyData[field].image = image.id
        setData({...copyData})
    }
    function getImageById (id) {
        const found = images.find(i => i.id === id)
        let path = ''
        if (found) {
            path = found.path
        }
        return path
    }
    function setColor (field, color) {
        const copyData = data
        copyData[field].color = color
        setData({...copyData})
    }
    function start () {
        if (!data.firstImage.image ||!data.secondImage.image) {
            return alert("Пожалуйста, выберите картинки")
        }
        setPage(pages.PAGE_STATE_2)
    }
    function startMusic(image, audiofileSrc) {
        const copyData = data
        copyData.selectedImage = image
        setData({...copyData})
        const audio = new Audio('/assets/'+ audiofileSrc)
        setAudio(audio)
        setTimeout(() => {
            const wrap = document.querySelector('.game2-finish')
            if (wrap) {
                wrap.classList.add('game2-finish--show')
                audio.play();
            }
        }, 100)
    }
    function resetGame () {
        setPage(pages.PAGE_STATE_1)
        setData({
            firstImage: {
                image: null,
                color: ''
            },
            secondImage: {
                image: null,
                color: ''
            },
            selectedImage: null
        })
        audio.pause();
        audio.currentTime = 0;
    }

    return (
        <>
            <div className="game2-wrapper">
                {page === pages.PAGE_STATE_1 && <>
                  <div className="game2-wrapper__row game2-wrapper__row-top">
                    <div className="game2-wrapper__col">
                      <div className="game2-constructor">
                        <div className="game2-constructor__tab" style={{boxShadow: data.firstImage.color ? `0px 0px 10px -2px ${data.firstImage.color}`: '#fff'}}>
                          <div className="game2-constructor__top">
                            <div className="game2-constructor__selected-image">
                                {data.firstImage.image && <img src={getImageById(data.firstImage.image)} alt="Картинка"/>}
                            </div>
                          </div>
                          <div className="game2-constructor__tab-center">
                            <div className="game2-constructor__text">Используйте пробел</div>
                          </div>
                          <div className="game2-constructor__tab-bottom">
                            <div className="game2-constructor__colors">
                                {colors.map(i => {
                                    return <div className="game2-constructor__colors-item"
                                                onClick={() => setColor('firstImage', i)}
                                                style={{backgroundColor: i}}/>
                                })}
                            </div>
                          </div>
                        </div>
                        <div className="game2-constructor__images">
                            {images.map(i => {
                                return <div
                                    style={{filter: i.id === data.firstImage.image && data.firstImage.color ? `drop-shadow(5px 1px 2px ${data.firstImage.color})`: 'none'}}
                                    onClick={() => selectImage('firstImage', i)}
                                    className={classNames({
                                        "game2-constructor__images-item": true,
                                        "game2-constructor__images-item--selected": i.id === data.firstImage.image,
                                    })}>
                                    <img src={i.path} alt="Картинка"/>
                                </div>
                            })}
                        </div>
                      </div>
                    </div>
                    <div className="game2-wrapper__col">
                      <div className="game2-constructor">
                        <div className="game2-constructor__tab" style={{boxShadow: data.secondImage.color ? `0px 0px 10px -2px ${data.secondImage.color}`: '#fff'}}>
                          <div className="game2-constructor__top">
                            <div className="game2-constructor__selected-image">
                                {data.secondImage.image && <img src={getImageById(data.secondImage.image)} alt="Картинка"/>}
                            </div>
                          </div>
                          <div className="game2-constructor__tab-center">
                            <div className="game2-constructor__text">Используйте enter</div>
                          </div>
                          <div className="game2-constructor__tab-bottom">
                            <div className="game2-constructor__colors">
                                {colors.map(i => {
                                    return <div className="game2-constructor__colors-item"
                                                onClick={() => setColor('secondImage', i)}
                                                style={{backgroundColor: i}}/>
                                })}
                            </div>
                          </div>
                        </div>
                        <div className="game2-constructor__images">
                            {images.map(i => {
                                return <div
                                    style={{filter: i.id === data.secondImage.image && data.secondImage.color ? `drop-shadow(5px 1px 2px ${data.secondImage.color})`: 'none'}}
                                    onClick={() => selectImage('secondImage', i)}
                                    className={classNames({
                                        "game2-constructor__images-item": true,
                                        "game2-constructor__images-item--selected": i.id === data.secondImage.image,
                                    })}>
                                    <img src={i.path} alt="Картинка"/>
                                </div>
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="game2-wrapper__row">
                    <button
                      onClick={() => start()}
                      className="game2-wrapper__btn MuiButtonBase-root MuiButton-root MuiButton-contained jss33 MuiButton-containedPrimary"
                      type="button"><span className="MuiButton-label"><span
                      className="jss34">Играть</span>
                    </span><span className="MuiTouchRipple-root"></span></button>
                  </div>
                </>}
                {page === pages.PAGE_STATE_2 && <>
                    <div className="game2-start">
                      <div className="game2-start__container">
                        <div className="game2-start__btn"
                             onClick={() => startMusic(data.firstImage.image, 'new-audio-1.mp3')}
                             style={{backgroundColor: data.firstImage.color}}>
                          <img src={getImageById(data.firstImage.image)} alt="Картинка"/>
                        </div>
                        <div className="game2-start__btn"
                             onClick={() => startMusic(data.secondImage.image, 'new-audio-2.mp3')}
                             style={{backgroundColor: data.secondImage.color}}>
                          <img src={getImageById(data.secondImage.image)} alt="Картинка"/>
                        </div>
                      </div>
                    </div>
                </>}
                {data.selectedImage && <div className='game2-finish' onClick={() => resetGame()}>
                  <img src={getImageById(data.selectedImage)} alt="картинка"/>
                </div>}

            </div>
        </>
    );
})

export default GamesChoose2
